import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=3dc39a7c&scoped=true&"
import script from "./Icon.vue?vue&type=script&lang=js&"
export * from "./Icon.vue?vue&type=script&lang=js&"
import style0 from "./Icon.vue?vue&type=style&index=0&id=3dc39a7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc39a7c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Icon.vue
// module id = null
// module chunks = 